module.exports = [{"id":0,"name":"Art & Animation"},{"id":2,"name":"Audio & Video"},{"id":3,"name":"Design"},{"id":4,"name":"Programming"},{"id":5,"name":"Quality Assurance"},{"id":6,"name":"Community"},{"id":7,"name":"IT & Web Development"},{"id":8,"name":"Publishing, Marketing & Sales"},{"id":9,"name":"Operations"},{"id":10,"name":"Production"},{"id":11,"name":"Internships"},{"id":12,"name":"Other"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/departments.json
// module id = dVN9
// module chunks = 1